// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"273":"blocks2","475":"blocks0"}[chunkId] || chunkId) + "." + {"273":"15f893b4","475":"f1e9b63a","915":"d31917d5"}[chunkId] + ".js";
};